import { Button, withStyles } from '@material-ui/core';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

class _Button extends React.Component {

    render() {

        const { classes, className, elevated, ...props } = this.props
        return (
            <Button
                className={cn(
                    className,
                    classes.root,
                    {
                        [classes.rootSecondary]: props.color === 'secondary',
                        [classes.rootSecondaryOutlined]: props.variant === 'outlined' && props.color === 'secondary',
                        [classes.rootElevated]: elevated
                    }
                )}
                {...props} />
        )
    }

}

_Button.propTypes = {
    classes: PropTypes.any,
    elevated: PropTypes.bool
}

const styles = theme => ({
    root: {
        borderRadius: 192,
        color: '#FFFFFF',
        boxShadow: `none`
    },
    rootSecondary: {
        color: theme.palette.secondary.contrastText,
    },
    rootSecondaryOutlined: {
        color: theme.palette.secondary.light,
        borderColor: theme.palette.secondary.light,
        borderWidth: 2
    },
    rootElevated: {
        boxShadow: `0 16px 24px 2px rgba(0,0,0,0.07), 0 6px 30px 5px rgba(0,0,0,0.06), 0 8px 10px -7px rgba(0,0,0,0.1)`
    }
})

export default withStyles(styles)(_Button)


// WEBPACK FOOTER //
// ./src/components/common/Button.js